<template>
  <Layout>
    <div class="p-2 text-xl text-gray-900">
      <h3 class="pl-2 font-bold">Úprava Rezervace</h3>
    </div>
    <form
      method="POST"
      :action="
        $route('updateReservation', {
          reservation: reservation.id,
          notify: notify,
        })
      "
    >
      <input type="hidden" name="_method" value="PUT" />

      <div class="flex justify-center">
        <div class="pt-10">
          <label
            class="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase"
            for="od"
          >
            Od
          </label>
          <input
            disabled
            id="od"
            type="date"
            :value="reservation.from"
            class="block w-48 px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-50 border border-gray-200 rounded focus:outline-none focus:bg-white"
            placeholder="Datum Od"
          />

          <label
            class="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase"
            for="do"
          >
            Do
          </label>
          <input
            disabled
            id="do"
            type="date"
            :value="reservation.to"
            class="block w-48 px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-50 border border-gray-200 rounded focus:outline-none focus:bg-white"
            placeholder="Datuom Do"
          />

          <label
            class="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase"
            for="type"
          >
            Počet Lidí
          </label>
          <input
            id="pocetLidi"
            type="text"
            name="pocetLidi"
            :value="reservation.pocetLidi"
            class="block w-48 px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-50 border border-gray-200 rounded focus:outline-none focus:bg-white"
            placeholder="Počet Lidí"
          />

          <label
            class="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase"
            for="type"
          >
            Typ
          </label>
          <select
            @change="reservationChangedTo"
            id="type"
            name="type"
            class="block w-48 px-4 py-3 pr-8 leading-tight text-gray-700 bg-gray-50 border border-gray-200 rounded focus:outline-none focus:bg-white"
          >
            <option v-if="reservation.type == 'ob'" value="ob" selected>
              Obsazeno
            </option>
            <option v-else value="ob">Obsazeno</option>

            <option v-if="reservation.type == 'rez'" value="rez" selected>
              Rezervace
            </option>
            <option v-else value="rez">Rezervace</option>
          </select>

          <label
            class="block pt-10 mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase"
            for="type"
          >
            Jméno
          </label>
          <input
            id="name"
            type="text"
            name="name"
            :value="customer ? customer.name : ''"
            class="block w-48 px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-50 border border-gray-200 rounded focus:outline-none focus:bg-white"
            placeholder="Jméno"
          />

          <label
            class="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase"
            for="type"
          >
            Email
          </label>
          <input
            id="email"
            type="email"
            name="email"
            :value="customer ? customer.email : ''"
            class="block w-48 px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-50 border border-gray-200 rounded focus:outline-none focus:bg-white"
            placeholder="Email"
          />

          <label
            class="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase"
            for="type"
          >
            Mobil
          </label>
          <input
            id="mobile"
            type="text"
            name="mobile"
            :value="customer ? customer.mobile : ''"
            class="block w-48 px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-50 border border-gray-200 rounded focus:outline-none focus:bg-white"
            placeholder="Mobil"
          />

          <label
            class="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase"
            for="type"
          >
            Zpráva
          </label>
          <textarea
            id="message"
            type="text"
            name="message"
            class="block w-48 px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-50 border border-gray-200 rounded focus:outline-none focus:bg-white"
            placeholder="Zpráva"
            >{{ reservation.message }}</textarea
          >
          <Link
            class="py-2 px-3 mt-8 mr-2 bg-gray-50 border border-gray-300 rounded"
            :href="$route('rezervace')"
            >Zrušit</Link
          >
          <button
            type="submit"
            class="py-2 px-3 mt-8 text-white bg-blue-600 rounded"
          >
            Uložit rezervaci
          </button>
        </div>
        <div class="pt-16">
          <date-picker
            :from="reservation.from"
            :to="reservation.to"
          ></date-picker>
        </div>
      </div>
    </form>
  </Layout>
</template>

<script>
import Layout from "../../../Layouts/admin.vue";
import DatePicker from "../../../components/DatePicker.vue";
import { Link } from "@inertiajs/inertia-vue3";
import useConfirm from "../../../ConfirmDialog/useConfirm";

import { ref } from "vue";

export default {
  components: {
    Layout,
    DatePicker,
    Link,
  },

  props: ["reservation", "customer"],

  setup() {
    const { show } = useConfirm();

    const notify = ref(false);

    const reservationChangedTo = async () => {
      const sendNotification = await show({
        type: "info",
        message: "Poslat email o změně na obsazeno",
        confirm: "Poslat email po uložení",
        cancel: "Neposílat",
      });

      if (sendNotification) {
        notify.value = true;
      }
    };

    return {
      reservationChangedTo,
      notify,
    };
  },
};
</script>
